/**
 * 严肃声明：
 * 开源版本请务必保留此注释头信息，若删除我方将保留所有法律责任追究！
 * 本系统已申请软件著作权，受国家版权局知识产权以及国家计算机软件著作权保护！
 * 可正常分享和学习源码，不得用于违法犯罪活动，违者必究！
 * Copyright (c) 2020 陈尼克 all rights reserved.
 * 版权所有，侵权必究！
 */
import axios from 'axios'
import { Toast } from 'vant'
import router from '../router'

// axios.defaults.baseURL = process.env.NODE_ENV == 'development' ? '//test-mall-api.oiltour.cn/api/v1' : '//test-mall-api.oiltour.cn/api/v1'
axios.defaults.baseURL = process.env.NODE_ENV == 'development' ? '//mall-api.oiltour.cn/api/v1' : '//mall-api.oiltour.cn/api/v1'
axios.defaults.withCredentials = true
axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.headers['token'] = localStorage.getItem('token') || ''
axios.defaults.headers.post['Content-Type'] = 'application/json'

axios.interceptors.response.use(res => {
  if (typeof res.data !== 'object') {
    Toast.fail('服务端异常！')
    return Promise.reject(res)
  }
  if (res.data.resultCode != 200) {
    if (res.data.message) Toast.fail(res.data.message)
    if (res.data.resultCode == 416) {
      console.log('416啦');
      router.push({ path: '/login' })
    }
    if( res.data.resultCode == 1000 ) { // 小程序端修改了密码，跳商城列表页（token 未过期时，不让其走后面的流程，防止串token）
      Toast.loading({
        type: 'fail',
        duration: 0,
        message:res.data.message,
        overlay: true,
        closeOnClick:true
      });
    }
    return Promise.reject(res.data)
  }

  return res.data
})

export default axios
